export default {"src":"/_next/static/media/beef-outline-icon.f52c49c0.svg","height":30,"width":45,"blurWidth":0,"blurHeight":0};